import { SapKey } from '../../types/types'
export const dxKoneConnectivityDeviceValue = 'cpuc'
export const dxServices: SapKey[] = ['KCSM_REMOTE_INTERVENTIONS']
export const dcsServicesForGrpTag = ['kone destination 1020', 'kone destination 880', 'kone destination 820']
